import merge from 'deepmerge'

// Array merge strategy:
const overwriteMerge = (destinationArray, sourceArray) => sourceArray

export function settingsCascade(baseSettings, extendSettings) {
	// [!] .freeze settings to avoid being observed by Vue !!!
	return Object.freeze(merge(baseSettings || {}, extendSettings || {}, { arrayMerge: overwriteMerge }))
}
